import {sortBy} from 'lodash'

const initialState = {
  pendingInvoices: [],
  ui:{
    loading: true
  }
}

export default function pendingInvoices(state = initialState, action){
  switch (action.type) {
    case "BEGIN_RESEND_PENDING_INVOICE_EMAIL":
      var invoiceBeingResent = state.pendingInvoices.find(invoice=>invoice.id == action.payload)
      invoiceBeingResent.resend_status = 'resending'
      return {
        ...state,
        pendingInvoices: [
          invoiceBeingResent,
          ...state.pendingInvoices.filter(invoice=>invoice.id != action.payload)
        ]
      }
    case "SUCCESS_RESEND_PENDING_INVOICE_EMAIL":
      var invoiceBeingResent = state.pendingInvoices.find(invoice=>invoice.id == action.payload)
      invoiceBeingResent.resend_status = 'resend_successful'
      return {
        ...state,
        pendingInvoices: [
          invoiceBeingResent,
          ...state.pendingInvoices.filter(invoice=>invoice.id != action.payload)
        ]
      }
    case "FAILED_RESEND_PENDING_INVOICE_EMAIL":
        var invoiceBeingResent = state.pendingInvoices.find(invoice=>invoice.id == action.payload)
        invoiceBeingResent.resend_status = 'error'
        return {
          ...state,
          pendingInvoices: [
            invoiceBeingResent,
            ...state.pendingInvoices.filter(invoice=>invoice.id != action.payload)
          ]
        }
    case "SUCCESS_FETCH_PENDING_INVOICES":
      return {
        ...state,
        pendingInvoices: sortBy(action.payload, ['due_date', 'id']).reverse(),
        ui: {
          ...state.ui,
          loading: false
        }
      }
    case "UPDATE_PENDING_INVOICES_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "ADD_INVOICE":
      return {
        ...state,
        pendingInvoices: [
          action.payload,
          ...state.pendingInvoices,
        ]
    }
    case "RESEND_INVOICE":
      var selectedInvoice = state.pendingInvoices.filter(invoice=>invoice.id === action.payload.id)[0]
      selectedInvoice.invoiced_on = action.payload.invoiced_on
      return {
        ...state,
        pendingInvoices: [
          selectedInvoice,
          ...state.pendingInvoices.filter(invoice=>invoice.id !== action.payload.id),
        ]
      }
    case "REMOVE_INVOICE":
      return {
        ...state,
        pendingInvoices: state.pendingInvoices.filter(invoice => invoice.id !== action.payload.id ),
      }
    default:
      return state;
  }
} 